import { callFunction } from "./functions-client";

// HOS companion log book (LOS Phase 20 F3, ELD Tier 1). A record-keeping companion —
// NOT a certified ELD (ADR-0021).
export const DUTY_STATUSES = ["off_duty", "sleeper", "driving", "on_duty"] as const;
export type DutyStatus = (typeof DUTY_STATUSES)[number];

export const DUTY_LABELS: Record<DutyStatus, string> = {
  off_duty: "Off duty", sleeper: "Sleeper", driving: "Driving", on_duty: "On duty",
};

export interface HosSummary {
  current_status: DutyStatus;
  drive_hours: number;
  on_duty_hours: number;
  drive_remaining_hours: number;
  window_remaining_hours: number;
  cycle_hours: number;
  cycle_remaining_hours: number;
  break_needed: boolean;
  violations: string[];
}

export interface DutyEventRow { status: DutyStatus; started_at: string; location: string | null; note: string | null }
export interface Dvir { id: string; kind: string; defects: string | null; safe_to_operate: boolean; created_at: string }

export const setDutyStatus = (input: { status: DutyStatus; note?: string; location?: string; shipment_id?: string }) =>
  callFunction<{ ok: boolean; status: DutyStatus }>("logbook/status", { body: input });

export const getToday = () =>
  callFunction<{ summary: HosSummary; current: DutyStatus; events: DutyEventRow[] }>("logbook/today", { method: "GET" });

export const getDayLog = (date: string) =>
  callFunction<{ date: string; events: DutyEventRow[] }>(`logbook/log?date=${encodeURIComponent(date)}`, { method: "GET" });

export const exportRods = (from?: string, to?: string) => {
  const p = new URLSearchParams();
  if (from) p.set("from", from);
  if (to) p.set("to", to);
  const qs = p.toString();
  return callFunction<{ csv: string }>(`logbook/export${qs ? `?${qs}` : ""}`, { method: "GET" });
};

export const submitDvir = (input: { kind: "pre_trip" | "post_trip"; defects?: string; safe_to_operate: boolean; vehicle_id?: string }) =>
  callFunction<{ ok: boolean }>("logbook/dvir-submit", { body: input });

export const listDvirs = () =>
  callFunction<{ dvirs: Dvir[] }>("logbook/dvirs", { method: "GET" });

export const VIOLATION_LABELS: Record<string, string> = {
  drive_limit: "11-hour driving limit exceeded",
  window_limit: "14-hour window exceeded",
  break_required: "30-minute break required",
  cycle_limit: "70-hour cycle limit exceeded",
};
